// eslint-disable-next-line import/prefer-default-export
export const PROFILE_EDIT_BUTTON_TEST_ID = "PROFILE_EDIT_BUTTON_TEST_ID";
